import * as currencies from '@dinero.js/currencies';
import dinero from 'dinero.js';

/** Converts a number to a formatted currency string. */

export const numberWithCurrency = (
  value: number,
  currency: string | { code: string } | null = null,
  options: {
    currencyDisplay?: 'code' | 'name' | 'narrowSymbol' | 'symbol';
    locale?: string;
    maximumFractionDigits?: number;
    minimumFractionDigits?: number;
  } = {},
): string => {
  const { currencyDisplay, locale = 'en-US' } = options;

  const formatOptions: Intl.NumberFormatOptions & { currency?: string } = {
    minimumFractionDigits: 2,
    ...options,
  };

  const currencyCode =
    typeof currency === 'object' && currency !== null
      ? currency.code
      : currency;

  if (currencyCode) {
    formatOptions.style = 'currency';
    formatOptions.currency = currencyCode;
    formatOptions.currencyDisplay = currencyDisplay ?? 'code';
  }

  try {
    if (
      currencyCode &&
      currencies[currencyCode] &&
      currencies[currencyCode].exponent === 0
    ) {
      return dinero({
        amount: Number(value),
        currency: currencies[currencyCode].code,
        precision: currencies[currencyCode].exponent,
      }).toFormat();
    }

    return new Intl.NumberFormat(locale, formatOptions)
      .format(value)
      .replace(/\u00A0/g, ' ');
  } catch (_) {
    return `${value} ${currencyCode}`;
  }
};
